import Head from "next/head";
import PageLayout, { siteTitle } from "@/components/PageLayout";
import Link from "next/link";
import Image from "next/image";
import ProductService from "@/lib/services/products.js";
import SearchBuilder from "@/components/search_builder.js";
import ProductTileV2 from "@/components/product_tile_v2";
import { useState, useEffect } from "react";
import Qs from "qs";
import searchTranslator from "@/lib/search_translator.js";
import Loader from "@/components/loading_animation.js";
import { loadConfig } from "@/lib/utils.js";

function NewProductsPage(results) {
  const {
    products,
    initialSearch,
    page_layout,
    favicon,
    stylesheet
  } = results;
  const [isLoading, setIsLoading] = useState(false);
  const [prods, setProducts] = useState(products);

  useEffect(() => {
  }, []);
  return (
    <PageLayout
      title="New Products"
      page_layout={page_layout}
      cart_enabled={true}
      favicon={favicon}
      stylesheet={stylesheet}
    >
      <SearchBuilder initialSearch={initialSearch}>
        {
          (searchState) => {
            return (
              <section className="lexcms-new-products-page-container">
                <section className="lexcms-new-products-page-header-container">
                  <div className="lexcms-new-products-header">
                    <h1 className="lexcms-new-products-header-text">
                      Latest Products
                    </h1>
                  </div>
                </section>
                <section className="lexcms-new-products-page-body-container">
                  <div className="lexcms-product-tile-v2-grid-container">
                    {isLoading && <Loader />}
                    {
                      prods &&
                      prods.length > 0 &&
                      prods.map((product, i) => {
                        return (
                          <ProductTileV2
                            key={product.id}
                            product={product}
                            page={'new'}
                          />
                        );
                      })
                    }
                    {prods?.length <= 0 && (
                      <div className="lexcms-no-results-found-container">
                        <div className="lexcms-no-results-found-image"></div>
                        <h2 className="lexcms-no-results-found-text">
                          No New Products currently exist.
                        </h2>
                      </div>
                    )}
                  </div>
                </section>
              </section>
            )
          }
        }
      </SearchBuilder>
    </PageLayout>
  );
}

export async function getServerSideProps(context) {
  let token = context?.req?.headers['lex-api-token']
  let service = await ProductService.build(
    token,
    context.req?.headers.host
  );
  let new_q = context.query
  let apiFriendlyQ = searchTranslator(new_q, true);
  apiFriendlyQ.q = apiFriendlyQ.q || {}
  apiFriendlyQ.q['s'] = 'new_till_date desc'
  let search = await service.index(apiFriendlyQ, {per_page: 10});
  let pageConfig = loadConfig(service);
  return {
    props: { ...search, ...pageConfig },
  };
}

export default NewProductsPage;
